import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import { Button } from '@bringg/react-components';
import { ServiceArea } from '@bringg/types';
import { createRoot } from 'react-dom/client';
import { TFunction } from 'i18next';

import './info-window.scss';

export type Props = {
	serviceArea: Partial<ServiceArea>;
	t: TFunction;
	polygon: google.maps.Polygon;
	onEdit: () => void;
	readonly?: boolean;
	isEditSessionActive?: () => boolean;
};

let _infoWindow: google.maps.InfoWindow;

function getInfoWindow() {
	if (!_infoWindow) {
		_infoWindow = new google.maps.InfoWindow();
	}
	return _infoWindow;
}

export function closeInfoWindow() {
	_infoWindow?.close();
}

export function attachInfoWindow({ serviceArea, t, polygon, onEdit, readonly = false, isEditSessionActive }: Props) {
	const content = (
		<div id="info-popup" className="service-area-info-popup">
			<div className="info-header">
				<div className="info-name">{serviceArea.name}</div>
				{!readonly ? (
					<Button
						type="link"
						onClick={() => {
							getInfoWindow().close();
							onEdit();
						}}
					>
						<BringgIcon iconName={BringgFontIcons.Pencil} />
						{t('SERVICE_AREA.EDIT')}
					</Button>
				) : null}
			</div>
		</div>
	);

	const container = document.createElement('div');

	createRoot(container).render(content);

	polygon.addListener('mouseover', event => {
		if (polygon.getEditable() || isEditSessionActive?.()) {
			return;
		}

		getInfoWindow().setContent(container);
		getInfoWindow().setPosition(event.latLng);
		getInfoWindow().open(polygon.get('map'));
	});

	polygon.addListener('mouseout', () => {
		if (polygon.getEditable()) {
			return;
		}

		getInfoWindow().close();
	});

	return getInfoWindow();
}
